function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f2b65b81-93e1-45c5-8e87-e76531d9ce36{fill-rule:evenodd}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10,18.93A8.93,8.93,0,1,1,18.92,10,8.93,8.93,0,0,1,10,18.93ZM10,2A8.05,8.05,0,1,0,18,10,8.06,8.06,0,0,0,10,2Z",
  transform: "translate(-1.08 -1.07)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14,11.94a2,2,0,0,1-2,2H8.07a2,2,0,0,1-2-2V8.06a2,2,0,0,1,2-2h3.86a2,2,0,0,1,2,2Zm.91-3.88a2.94,2.94,0,0,0-2.94-2.94H8.07A2.94,2.94,0,0,0,5.13,8.06v3.88a2.94,2.94,0,0,0,2.94,2.94h3.86a2.94,2.94,0,0,0,2.94-2.94ZM10,11.6a1.54,1.54,0,1,1,1.54-1.53A1.53,1.53,0,0,1,10,11.6Zm0-3.95a2.41,2.41,0,1,0,2.42,2.42A2.42,2.42,0,0,0,10,7.65Zm2.56-.73a.58.58,0,1,0,0,1.15.58.58,0,0,0,0-1.15Z",
  className: "f2b65b81-93e1-45c5-8e87-e76531d9ce36",
  transform: "translate(-1.08 -1.07)"
});

var SvgHandlesSocialIconInstagram = function SvgHandlesSocialIconInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a186c61c-7fdf-4803-b2be-2bb1711efa71",
    "data-name": "Layer 1",
    viewBox: "0 0 17.85 17.87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandlesSocialIconInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Handles_SocialIcon_Instagram.98c418c3.svg";
export { ForwardRef as ReactComponent };